import React from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { MetricsConfiguration } from '@/features/chart-configuration/components/MetricsConfiguration';
import { DimensionsConfiguration } from '@/features/chart-configuration/components/DimensionsConfiguration';

import { TChartType } from '@/features/chart-configuration/apiSlice';
import {
  selectMetricsDimensionConfiguration,
  setQueryDimensions,
  setQueryMetrics,
} from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useGetQueryBuilderSummarizeConfig } from '@/features/queryConfig/hooks/useGetQueryBuilderSummarizeConfig';
import { AGGREGATE_CONFIGURATION_CHANGED } from '@/actions/constants';
import { useDataPresentationParam } from '@/hooks';

export const QueryMetricsDimensionsConfiguration = () => {
  const { data, isReady } = useGetQueryBuilderSummarizeConfig();
  const dispatch = useAppDispatch();
  const dataPresentation = useDataPresentationParam() as TChartType;
  const configuration = useAppSelector(selectMetricsDimensionConfiguration)[
    dataPresentation
  ];

  const dataPresentationMetrics = configuration?.metrics ?? [];
  const dataPresentationDimensions = configuration?.dimensions ?? [];

  const onUserInteraction = () =>
    dispatch({ type: AGGREGATE_CONFIGURATION_CHANGED });

  if (!isReady || !data) return null;
  const columns = data[dataPresentation];

  if (!columns) return null;

  return (
    <>
      <MetricsConfiguration
        chartType={dataPresentation}
        onChange={(selectedMetrics) => {
          dispatch(
            setQueryMetrics({
              config: selectedMetrics,
              dataPresentation,
            }),
          );
        }}
        dimensions={dataPresentationDimensions}
        metricColumns={columns.metricColumns}
        prefill={configuration?.metrics}
        onUserInteraction={onUserInteraction}
      />
      <DimensionsConfiguration
        chartType={dataPresentation}
        onChange={(selectedDimensions) => {
          dispatch(
            setQueryDimensions({
              config: selectedDimensions,
              dataPresentation,
            }),
          );
        }}
        metrics={dataPresentationMetrics}
        dimensionColumnsCombinations={columns.dimensionColumnsCombinations}
        prefill={configuration?.dimensions}
        onUserInteraction={onUserInteraction}
      />
    </>
  );
};
